import React, { useEffect } from 'react';
import {
    AUTOMATIC_TAX_CALCULATION,
    IOrderSale,
    REQUIRE_TAX,
} from '../../order-sale-form';
import { RhCheckbox } from '../../../../../../../dum';
import { useCalculateProductsTotal } from '../../helpers/use-calculate-products-total';
import { useFormContext, useWatch } from 'react-hook-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function AutomaticTaxCalculationInput() {
    const { calculateProductsTotal } = useCalculateProductsTotal();
    const { setValue } = useFormContext<IOrderSale>();
    const requireTax = useWatch({
        name: REQUIRE_TAX,
    }) as IOrderSale['require_tax'];
    const automaticTaxCalculation = useWatch({
        name: AUTOMATIC_TAX_CALCULATION,
    }) as IOrderSale['automatic_tax_calculation'];

    useEffect(() => {
        if (!requireTax && automaticTaxCalculation) {
            setValue(AUTOMATIC_TAX_CALCULATION, false, {
                shouldDirty: true,
                shouldValidate: true,
            });
        }
    }, [
        automaticTaxCalculation,
        requireTax,
        setValue,
    ]);

    return (
        <RhCheckbox
            name={AUTOMATIC_TAX_CALCULATION}
            label={shortLabel(FIELD_LABELS.automatic_tax_calculation)}
            disabled={!requireTax}
            onChange={() => {
                calculateProductsTotal();
            }}
        />
    );
}
